import React from 'react'
import styles from './mystyles.module.css'

export default function Cp(props) {
    const color1={
        backgroundColor:props.color1
    }
    const color2={
        backgroundColor:props.color2
    }
    const color3={
        backgroundColor:props.color3
    }
    return (
        <div>
            <div className={styles.colorPallete}>
                <div className={styles.color + ' ' + styles.color1} style={color1}></div>
                <div className={styles.color + ' ' + styles.color2} style={color2}></div>
                <div className={styles.color + ' ' + styles.color3} style={color3}></div>
            </div>
        </div>
    )
}
